<script setup>
import { computed, ref, onMounted, onUnmounted } from "vue";
import { useStore } from "vuex";
import { useRoute,useRouter } from "vue-router";
import Breadcrumbs from "../Breadcrumbs.vue";
import { useAuthStore } from "@/store/authStore";

const store = useStore();
const isRTL = computed(() => store.state.isRTL);

const route = useRoute();
const router = useRouter(); // ✅ THIS IS WHAT YOU NEED
const auth = useAuthStore();

const currentRouteName = computed(() => route.name);
const currentDirectory = computed(() => {
  let dir = route.path.split("/")[1];
  return dir.charAt(0).toUpperCase() + dir.slice(1);
});

const showDropdown = ref(false);
const toggleDropdown = (e) => {
  e.preventDefault(); // ✅ Prevent page reload
  showDropdown.value = !showDropdown.value;
};

// ✅ Close dropdown when clicking outside
const handleClickOutside = (e) => {
  if (!e.target.closest(".profile-dropdown")) {
    showDropdown.value = false;
  }
};
const handleLogout = () => {
  auth.logout();
  router.push("/signin"); // ✅ Now this works!
};
onMounted(() => {
  document.addEventListener("click", handleClickOutside);
});

onUnmounted(() => {
  document.removeEventListener("click", handleClickOutside);
});
</script>

<template>
  <nav
    class="navbar navbar-main navbar-expand-lg px-0 mx-4 shadow-none border-radius-xl"
    :class="isRTL ? 'top-0 position-sticky z-index-sticky' : ''"
    v-bind="$attrs"
    id="navbarBlur"
    data-scroll="true"
  >
    <div class="px-3 py-1 container-fluid">
      <breadcrumbs :current-page="currentRouteName" :current-directory="currentDirectory" />

      <!-- Profile Dropdown -->
      <ul class="navbar-nav ms-auto d-flex align-items-center">
        <li class="nav-item dropdown profile-dropdown position-relative">
          <a
            href="#"
            class="nav-link text-body font-weight-bold px-0 d-flex align-items-center"
            @click="toggleDropdown"
          >
            <i class="fas fa-user-circle fa-lg me-2"></i>

            <!-- Hide this part on mobile -->
            <span class="d-none d-sm-inline">
              Acciones de Cuenta
              <i :class="`fas ${showDropdown ? 'fa-chevron-down' : 'fa-chevron-right'} ms-1`"></i>
            </span>
          </a>
          <ul
            v-if="showDropdown"
            class="dropdown-menu show dropdown-menu-end mt-2 py-2 shadow rounded"
            style="display: block; position: absolute;"
          >
            <li><a class="dropdown-item" href="/profile">Perfil</a></li>
            <li><hr class="dropdown-divider" /></li>
            <li><a class="dropdown-item text-danger" @click="handleLogout">Cerrar sesión</a></li>
          </ul>
        </li>
      </ul>
    </div>
  </nav>
</template>
